import { useDispatch, useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';
import iconChevronLeftPrimaryUrl from '../../assets/icon/chevron-left-primary.svg';
import loginBannerUrl from '../../assets/images/LoginBanner.svg';
import { resetStateAction } from '../../store/login/actions';
import { getCustomerCode, getPhoneNumber } from '../../store/login/selectors';
import LanguagePicker from "../../components/LanguagePicker";
import loginBannerUrlPhone from '../../assets/images/LoginBannerPhone.svg';
import logoUrl from '../../assets/icon/Logo.svg';
import { getWebViewPartnerName, isWebView } from '../../utilities/webview';
import './index.scss';

const BackArrowIcon = () => (
  <svg width="30" height="30" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15 10H5M5 10L9 6M5 10L9 14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export interface LoginLayoutProps {
  root?: boolean;
}

const LoginScreen = (props: LoginLayoutProps) => {
  const { root = false } = props;
  const dispatch = useDispatch();
  const phone = useSelector(getPhoneNumber);
	const customerCode = useSelector(getCustomerCode);

  const webView = isWebView();
  const partnerRaw = getWebViewPartnerName() ?? '';
  const isVikkiPartner = partnerRaw.toLowerCase() === 'vikki_bank' || partnerRaw.toLowerCase() === 'vikki';

  const handleBack = () => {
    dispatch(resetStateAction({phone, customerCode, canForgotPassword: false}));
    window.history.back();
  };

  const handleWebViewBack = () => {
    const message = JSON.stringify({ event: 'CLOSED' });
    const rn = (window as any).ReactNativeWebView;
    if (rn) {
      rn.postMessage(message);
    } else {
      window.parent.postMessage(message, '*');
    }
  };

  if (webView) {
    return (
      <div className="login-container webview-mode">
        <div className="auth-webview-header-container">
          <div className="auth-webview-header">
            <div className="auth-webview-top-wrap">
              <div className="auth-webview-logo-row">
                <button
                  className={`auth-webview-back-btn${isVikkiPartner ? ' auth-webview-back-btn--vikki' : ''}`}
                  onClick={handleWebViewBack}
                >
                  <BackArrowIcon />
                </button>
                <div className="auth-webview-logo-center">
                  <img src={logoUrl} alt="Swift247" height="40" />
                </div>
                <LanguagePicker className="auth-webview-lang-picker" />
              </div>
            </div>
          </div>
        </div>
        <div className="login-form-container">
          <div className="login-form">
            <div className="login-field">
              <Outlet />
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="login-container">
      <img className="banner-img" src={loginBannerUrl} alt="logo" />
      <img className="banner-img-phone" src={loginBannerUrlPhone} alt="logo-phone" />
      <div className="login-form-container">
        <LanguagePicker className={'layout-language-picker'}/>
        <div className="login-form">
          {!root && (
            <div className='back-button-wrap'>
              <div className="back-button" onClick={handleBack}>
                <img
                  src={iconChevronLeftPrimaryUrl}
                  style={{ marginInline: '8px', color: 'rgb(179, 68, 109)', fontSize: '16px' }}
                />
              </div>
            </div>
          )}
          <div className="login-field">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginScreen;
